import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { Routes } from '@/routes/routes';

const GmcConfigsPage = lazy(() => import('@/pages/gmc/GmcConfigsPage'));
const GmcLogsPage = lazy(() => import('@/pages/gmc/GmcLogsPage'));

export const gmcRoutes: RouteObject[] = [
	{ path: Routes.GMC_CONFIGS, element: <GmcConfigsPage /> },
	{ path: Routes.GMC_LOGS, element: <GmcLogsPage /> },
];
